import { GuidesSegment } from './guides-segment';
import { SupportSegment } from './support-segment';
import { WebsiteCoreSegment } from './website-core-segment';
import useSegment from '~lib/frontend/hooks/use-segment';

export const useSupportContent = (): SupportSegment => useSegment('website_support') as SupportSegment;
export const useGuideContent = (): GuidesSegment => useSegment('website_guides') as GuidesSegment;
export const useWebsiteCoreContent = (): WebsiteCoreSegment => useSegment('website_core') as WebsiteCoreSegment;
